// T022: Implement RC (Resource Credits) service

import { getSteemitClient } from './client'
import { RCAccount } from '@/types/steemit'

export interface RCInfo {
  percentage: number
  current: number
  max: number
}

/**
 * Fetches Resource Credits for a user
 */
export async function getUserRC(username: string): Promise<RCInfo> {
  try {
    const client = getSteemitClient()

    const result = await client.call('rc_api', 'find_rc_accounts', {
      accounts: [username],
    })

    if (!result?.rc_accounts || result.rc_accounts.length === 0) {
      throw new Error('RC account not found')
    }

    const rcAccount: RCAccount = result.rc_accounts[0]
    const currentMana = parseInt(rcAccount.rc_manabar.current_mana)
    const maxRC = parseInt(rcAccount.max_rc)
    const percentage = (currentMana / maxRC) * 100

    return {
      percentage,
      current: currentMana,
      max: maxRC,
    }
  } catch (error) {
    console.error('Failed to fetch RC:', error)
    throw new Error('Failed to fetch Resource Credits')
  }
}

/**
 * Checks if user has enough RC for an operation
 */
export async function checkRC(
  username: string,
  minPercentage: number = 10
): Promise<boolean> {
  try {
    const rc = await getUserRC(username)
    return rc.percentage >= minPercentage
  } catch {
    return false
  }
}

/**
 * Estimates RC cost for a post/comment
 * (This is a rough estimate - actual cost varies)
 */
export function estimateRCCost(contentLength: number): number {
  // Rough estimate: ~1% RC for a typical post
  const baseRC = 0.5
  const lengthFactor = contentLength / 1000
  return baseRC + lengthFactor * 0.2
}
